import axiosInstance from 'utils/axiosInstance';

export const getSinistreApi = ({ language }: { language: string }) => {
  return axiosInstance.get('/claims', {
    params: { lang: language },
  });
};

export const getSinistreDetailsApi = ({
  language,
  claimNumber,
}: {
  language: string;
  claimNumber: String;
}) => {
  return axiosInstance.get(`/get-claim-details/${claimNumber}`, {
    params: { lang: language },
  });
};

export function getRefundsAMCApi(payload: any) {
  const filter = {};
  const apiUrl = `/health/amcRefunds?page=${payload.page}&perPage=${payload.perPage}`;
  return axiosInstance.post(apiUrl, { filter });
}

export function getDetailRefundAMCApi(payload: any) {
  return axiosInstance.get(
    `/health/amcDetailRefund?numDossier=${payload.payload.numeroApplication}&numPolice=${payload.payload.numeroPolicy}`,
  );
}
